(function() {
  define('bazemont/shared/datepicker',['angular'], function() {
    'use strict';
    return angular.module('bazemontDatepicker', []).component('bazemontDatepicker', {
      templateUrl: '/assets/javascripts/bazemont/shared/datepicker.html',
      bindings: {
        date: '=',
        datepickerOptions: '<',
        label: '@',
        info: '@'
      },
      controller: [
        '$scope', function($scope) {
          var vm;
          vm = this;
          vm.datepicker = false;
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=datepicker.js.map
;
